import { NavSideItem } from './interfaces/nav.interfaces';

export const navSideData: NavSideItem[] = [
  {
    routerLink: ['/admin', 'home'],
    icon: 'fal fa-home',
    label: 'admin.home',
  },
  {
    routerLink: ['/admin', 'expertises'],
    icon: 'fal fas fa-tools',
    label: 'admin.services',
  },
  {
    routerLink: ['/admin', 'projects'],
    icon: 'fal fa-regular fa-folder-open',
    label: 'admin.projects',
  },
  {
    routerLink: ['/admin', 'news'],
    icon: 'fal fa-regular fa-newspaper',
    label: 'admin.news',
  },
  {
    routerLink: ['/admin', 'insights'],
    icon: 'fal fa-lightbulb',
    label: 'admin.insights',
  },
  {
    routerLink: ['/admin', 'careers'],
    icon: 'fal fa-solid fa-briefcase',
    label: 'admin.careers',
  },
  {
    routerLink: ['/admin', 'policy'],
    icon: 'fal fas fa-book',
    label: 'admin.policy',
  },
  {
    routerLink: ['/admin', 'accreditation'],
    icon: 'fal fas fa-certificate',
    label: 'admin.accreditation',
  },
  {
    routerLink: ['/admin', 'leadership'],
    icon: 'fal fas fa-user-tie',
    label: 'admin.leadership',
  },
  {
    routerLink: ['/admin', 'story'],
    icon: 'fal fas fa-history',
    label: 'admin.story',
  },
  {
    routerLink: ['/admin', 'contacts'],
    icon: 'fal fas fa-map-marked-alt',
    label: 'admin.contacts',
  },
  {
    routerLink: ['/admin'],
    icon: 'fal fa-user',
    label: 'admin.profile',
  },
];
